const data = [
    { id: 1, name: "PENDENTE", color: 'yellow' },
    { id: 2, name: "EMBARCOU", color: 'green' },
    { id: 3, name: "NÃO EMBARCOU", color: 'red' },
]

export default [...data]